"use client";
import { useEffect, useState } from "react";

/**
 * Réagit à un media query CSS (ex: "(min-width: 768px)").
 * SSR-safe : retourne `false` côté serveur, hydrate au premier render client.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const mql = window.matchMedia(query);
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches);
    setMatches(mql.matches);
    mql.addEventListener("change", handler);
    return () => mql.removeEventListener("change", handler);
  }, [query]);

  return matches;
}

export const useIsMobile = () => !useMediaQuery("(min-width: 768px)");
export const useIsTablet = () =>
  useMediaQuery("(min-width: 768px) and (max-width: 1023px)");
export const useIsDesktop = () => useMediaQuery("(min-width: 1024px)");
export const usePrefersReducedMotion = () =>
  useMediaQuery("(prefers-reduced-motion: reduce)");
export const usePrefersDark = () =>
  useMediaQuery("(prefers-color-scheme: dark)");
